
  import { Vue, Component, Prop } from "vue-property-decorator";

  import SpinnerIcon from "@/components/icons/SpinnerIcon.vue";

  @Component({
    components: {
      SpinnerIcon,
    },
  })
  export default class Spinner extends Vue {
    @Prop({ type: String, default: undefined }) readonly size!: string;
    @Prop({ type: String, default: undefined }) readonly color!: string;

    get iconStyles(): Object {
      return {
        "animate-spin": true,
        [this.iconSize]: true,
        [this.iconColor]: true,
      };
    }

    get iconColor(): string {
      switch (this.color) {
        case "secondary":
          return "text-white"
        default:
          return "text-primary-600"

      }
    }

    get iconSize(): string {
      switch (this.size) {
        case "sm":
          return "h-5 w-5";
        default:
          return "h-6 w-6";
      }
    }
  }
